import axios from "axios";
import { BSON as Oid } from "realm-web";
import { Socket } from "socket.io-client";
import { IImages, IMessage } from "src/app/types";
import { appConfig } from "app/configs/appConfig";
import { useSocketStore } from "app/store/socketStore";
// import { socketService } from "../services/socket-manager";
import { CreateImageBody, IChatImageModel, ISocketEvent } from "../interfaces/chat-image";
import { ChatMessage } from "./chat-message";

const SocketEvents: ISocketEvent = {
    create: "message-image::create",
    fetch: "message-image::fetch",
};

// class ChatImageModel implements IChatImageModel {
class ChatImageModel {
    events: typeof SocketEvents;
    socket: Socket | null;
    socketURL: string;
    serverURL: string;

    _id: string;
    message: string;
    image: string | null;

    constructor(imageValues?: Partial<IImages>[]) {
        this.events = SocketEvents;
        this.socket = useSocketStore.getState().messageSocket;
        this.socketURL =
            process.env.NODE_ENV === "development" ? appConfig.localChatSocketURL : appConfig.socketChatBaseURL;
        this.serverURL =
            process.env.NODE_ENV === "development" ? appConfig.localChatServerURL : appConfig.serverChatBaseURL;
        this.updateValues(imageValues);
    }

    updateValues = (newValues: Partial<IImages>[]) => {
        newValues?.forEach((imageValue) => {
            for (let field in imageValue) {
                const val = imageValue[field];
                if (val !== null) {
                    switch (field) {
                        case "_id":
                        case "message":
                            if (typeof val === "string") {
                                //@ts-ignore
                                this[field] = Oid.ObjectID.createFromHexString(val);
                            } else {
                                this[field] = val;
                            }
                            break;
                        default:
                            this[field] = val;
                            break;
                    }
                }
            }
        });
        return this;
    };

    get docValues(): Partial<IImages>[] {
        return [
            {
                _id: this._id,
                message: this.message,
                image: this.image,
            },
        ];
    }

    sendToSocket = async (event: string, params?: any) => {
        // const _this = new ChatMessage();
        // _this.socket.emit(event, params);
        this.socket.emit(event, params);
    };

    sendToEndpoint = async (type: "get" | "post", params?: any) => {
        const _this = new ChatImageModel();
        if (type === "post") {
            return (await axios.post(`${_this.serverURL}/image`, { params })).data;
        }
        return (await axios.get(`${_this.serverURL}/image`, { params: { ...params } })).data;
    };

    async makeRequest(event: string, type: "get" | "post", payload?: any) {
        // if (!this.socket.connected) {
        //     return await this.sendToEndpoint(type, payload);
        // }
        this.sendToSocket(event, payload);
    }

    async create(payload: CreateImageBody) {
        return await this.makeRequest(this.events.create, "post", payload);
    }

    async fetchImages(messageId: string) {
        // const _this = new ChatImageModel();
        // _this.sendToSocket(_this.events.fetch, { messageId });
        return await this.makeRequest(this.events.fetch, "get", { messageId });
    }

    async sendImages(message: Partial<IMessage>, images: Partial<IImages>[]) {
        let payload = { images, message };
        return await this.create(payload);
    }
}

export { ChatImageModel };
